import { useState } from 'react';
import { useAuthContext } from '../contexts/AuthContext';
import { isset } from './index';

export function useGetTextParameter() {
    const { auth } = useAuthContext();
    const { languageId } = auth;
    const getTextParameter = (parameter) => {
        if (Array.isArray(parameter)) {
            if (parameter.length > languageId) {
                return parameter[languageId];
            }
            if (parameter.length) {
                return parameter[0];
            }
            return null;
        }
        return parameter;
    };

    return getTextParameter;
}

export function usePopupWindow() {
    const [windowObjectReference, setWindowObjectReference] = useState(null);
    const [currentUrl, setCurrentUrl] = useState(null);

    const parseParameters = (paramObject) => {
        const { width, height } = paramObject;
        const defaultParams = {
            resizable: true,
            scrollbars: true,
            status: false,
        };
        // center popup relative to parent
        if (
            isset(width) &&
            isset(height) &&
            isset(window?.top?.outerHeight) &&
            isset(window?.top?.outerWidth) &&
            isset(window?.top?.screenX) &&
            isset(window?.top?.screenY)
        ) {
            defaultParams.top =
                window.top.outerHeight / 2 + window.top.screenY - height / 2;
            defaultParams.left =
                window.top.outerWidth / 2 + window.top.screenX - width / 2;
        }
        const paramString = Object.entries(
            Object.assign({}, defaultParams, paramObject)
        ).reduce((prev, [key, value]) => {
            let strVal;
            if (typeof value === 'boolean') {
                strVal = value ? 'yes' : 'no';
            } else {
                strVal = value.toString ? value.toString() : value;
            }
            return `${prev}${prev.length ? ',' : ''}${key}=${strVal}`;
        }, '');
        return paramString;
    };

    function openPopup(url, options, windowName = 'popup') {
        const parameters = parseParameters(options);
        if (
            windowObjectReference &&
            !windowObjectReference.closed &&
            url === currentUrl
        ) {
            windowObjectReference.focus();
            return;
        }
        const newWindowObjectReference = window.open(
            url,
            windowName,
            parameters
        );
        if (windowObjectReference) {
            windowObjectReference.focus();
        }
        setWindowObjectReference(newWindowObjectReference);
        setCurrentUrl(url);
    }

    return openPopup;
}
